import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InboxNavTicketRowContent({
  content,
  contentDisplayName,
  requestedBy,
  requestedByDisplayName
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "50",
    children: [content ? /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-default",
      truncate: true,
      children: content
    }) : /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      truncate: true,
      fontStyle: "italic",
      children: contentDisplayName ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-portal-app.inboxNavPanel.ticketRow.propertyUnavailable",
        options: {
          propertyName: contentDisplayName
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-portal-app.inboxNavPanel.ticketRow.descriptionUnavailable"
      })
    }), typeof requestedBy === 'string' ? /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      truncate: true,
      children: requestedBy
    }) : requestedBy === null && /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      truncate: true,
      fontStyle: "italic",
      children: requestedByDisplayName ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-portal-app.inboxNavPanel.ticketRow.propertyUnavailable",
        options: {
          propertyName: requestedByDisplayName
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-portal-app.inboxNavPanel.ticketRow.requesterUnavailable"
      })
    })]
  });
}